const UrlApi = {
  // live
  baseUrl: `${process.env.REACT_APP_BASEURL}/admin/`,
  baseUrlImage: `${process.env.REACT_APP_BASEURL}/uploads/`,
  // local
  // baseUrl: "http://localhost:8000/admin/",
  // baseUrlImage: "http://localhost:8000/uploads/",
  // auth
  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    signup: "auth/signup",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
  },
  keyfeature: {
    get: "key_features/get",
    add: "key_features/add",
    edit: "key_features/edit",
    delete: "key_features/delete",
  },
  flashcard: {
    category: {
      get: "flash_cards/category/get",
      add: "flash_cards/category/add",
      edit: "flash_cards/category/edit",
      delete: "flash_cards/category/delete",
    },

    flashcard: {
      get: "flash_cards/flash_cards/get",
      getByCategory: "flash_cards/flash_cards/getByCategory",
      add: "flash_cards/flash_cards/add",
      edit: "flash_cards/flash_cards/edit",
      delete: "flash_cards/flash_cards/delete",
    },
    flashcardDetails: {
      get: "flash_cards/flash_card_details/get",
      add: "flash_cards/flash_card_details/add",
      edit: "flash_cards/flash_card_details/edit",
      delete: "flash_cards/flash_card_details/delete",
    },
    level_of_difficulty: {
      get: "flash_cards/level_of_difficulty/get",
      add: "flash_cards/level_of_difficulty/add",
      edit: "flash_cards/level_of_difficulty/edit",
      delete: "flash_cards/level_of_difficulty/delete",
    },
    age_range: {
      get: "flash_cards/age_range/get",
      add: "flash_cards/age_range/add",
      edit: "flash_cards/age_range/edit",
      delete: "flash_cards/age_range/delete",
    },
  },
  landingPage: {
    sliderShow: {
      get: "landing_page/slider_show/get",
      add: "landing_page/slider_show/add",
      edit: "landing_page/slider_show/edit",
      delete: "landing_page/slider_show/delete",
    },
    news: {
      get: "landing_page/news/get",
      gettypes: "landing_page/news/gettypes",
      add: "landing_page/news/add",
      edit: "landing_page/news/edit",
      delete: "landing_page/news/delete",
    },
    maps: {
      get: "landing_page/maps/get",
      add: "landing_page/maps/add",
      edit: "landing_page/maps/edit",
      delete: "landing_page/maps/delete",
    },
    languages: {
      get: "landing_page/languages/get",
      add: "landing_page/languages/add",
      edit: "landing_page/languages/edit",
      delete: "landing_page/languages/delete",
    },
    our_client: {
      get: "landing_page/our_client/get",
      add: "landing_page/our_client/add",
      edit: "landing_page/our_client/edit",
      delete: "landing_page/our_client/delete",
    },
    our_partner: {
      get: "landing_page/our_partner/get",
      add: "landing_page/our_partner/add",
      edit: "landing_page/our_partner/edit",
      delete: "landing_page/our_partner/delete",
    },
    testimonials: {
      get: "landing_page/testimonials/get",
      add: "landing_page/testimonials/add",
      edit: "landing_page/testimonials/edit",
      delete: "landing_page/testimonials/delete",
    },
    app_benefits: {
      get: "landing_page/app_benefits/get",
      add: "landing_page/app_benefits/add",
      edit: "landing_page/app_benefits/edit",
      delete: "landing_page/app_benefits/delete",
    },
    impacts: {
      get: "landing_page/impacts/get",
      add: "landing_page/impacts/add",
      edit: "landing_page/impacts/edit",
      delete: "landing_page/impacts/delete",
    },
    stats: {
      get: "landing_page/stats/get",
      add: "landing_page/stats/add",
      edit: "landing_page/stats/edit",
      delete: "landing_page/stats/delete",
    },
    products: {
      get: "landing_page/products/get",
      add: "landing_page/products/add",
      edit: "landing_page/products/edit",
      delete: "landing_page/products/delete",
    },
    products_videos: {
      get: "landing_page/products_videos/get",
      add: "landing_page/products_videos/add",
      edit: "landing_page/products_videos/edit",
      delete: "landing_page/products_videos/delete",
    },
    solutions: {
      get: "landing_page/solutions/get",
      add: "landing_page/solutions/add",
      edit: "landing_page/solutions/edit",
      delete: "landing_page/solutions/delete",
    },
    casestudies: {
      get: "landing_page/casestudies/get",
      add: "landing_page/casestudies/add",
      edit: "landing_page/casestudies/edit",
      delete: "landing_page/casestudies/delete",
    },
    services: {
      get: "landing_page/services/get",
      add: "landing_page/services/add",
      edit: "landing_page/services/edit",
      delete: "landing_page/services/delete",
    },
    ourteam: {
      get: "landing_page/ourteam/get",
      add: "landing_page/ourteam/add",
      edit: "landing_page/ourteam/edit",
      delete: "landing_page/ourteam/delete",
    },
    contactform: {
      get: "landing_page/contactform/get",
      add: "landing_page/contactform/add",
      edit: "landing_page/contactform/edit",
      delete: "landing_page/contactform/delete",
    },
    requestdemo: {
      get: "landing_page/requestdemo/get",
      add: "landing_page/requestdemo/add",
      edit: "landing_page/requestdemo/edit",
      delete: "landing_page/requestdemo/delete",
    },
    downloadfiles: {
      get: "landing_page/downloadfiles/downloadfiles/get",
      add: "landing_page/downloadfiles/downloadfiles/add",
      edit: "landing_page/downloadfiles/downloadfiles/edit",
      delete: "landing_page/downloadfiles/downloadfiles/delete",
    },

    downloadfiles_users: {
      get: "landing_page/downloadfiles/downloadfiles_users/get",
      add: "landing_page/downloadfiles/downloadfiles_users/add",
      edit: "landing_page/downloadfiles/downloadfiles_users/edit",
      delete: "landing_page/downloadfiles/downloadfiles_users/delete",
    },
  },
  settings: {
    get: "settings/get",
    edit: "settings/edit",
  },
  tips: {
    get: "tips/get",
    add: "tips/add",
    edit: "tips/edit",
    delete: "tips/delete",
  },
  how_it_work: {
    get: "how_it_work/get",
    add: "how_it_work/add",
    edit: "how_it_work/edit",
    delete: "how_it_work/delete",
  },
  industries: {
    industries: {
      get: "industries/industries/get",
      add: "industries/industries/add",
      edit: "industries/industries/edit",
      delete: "industries/industries/delete",
    },
    industries_products: {
      get: "industries/products/get",
      add: "industries/products/add",
      edit: "industries/products/edit",
      delete: "industries/products/delete",
    },
    industries_services: {
      get: "industries/services/get",
      add: "industries/services/add",
      edit: "industries/services/edit",
      delete: "industries/services/delete",
    },
    industries_solutions: {
      get: "industries/solutions/get",
      add: "industries/solutions/add",
      edit: "industries/solutions/edit",
      delete: "industries/solutions/delete",
    },
  },
  activities: {
    category: {
      get: "activities/category/get",
      add: "activities/category/add",
      edit: "activities/category/edit",
      delete: "activities/category/delete",
    },
    activities: {
      get: "activities/activities/get",
      add: "activities/activities/add",
      edit: "activities/activities/edit",
      delete: "activities/activities/delete",
    },
    activities_media: {
      get: "activities/activities_media/get",
      add: "activities/activities_media/add",
      edit: "activities/activities_media/edit",
      delete: "activities/activities_media/delete",
    },
    activities_flashcard: {
      get: "activities/activities_flashcard/get",
      add: "activities/activities_flashcard/add",
      edit: "activities/activities_flashcard/edit",
      delete: "activities/activities_flashcard/delete",
    },
  },
  topics: {
    get: "topics/get",
    add: "topics/add",
    edit: "topics/edit",
    delete: "topics/delete",
  },
  contact_as: {
    get: "contact_as/get",
    add: "contact_as/add",
    edit: "contact_as/edit",
    delete: "contact_as/delete",
  },
  addresses: {
    addresses: {
      get: "addresses/addresses/get",
      add: "addresses/addresses/add",
      edit: "addresses/addresses/edit",
      delete: "addresses/addresses/delete",
    },
    addresses_careers: {
      get: "addresses/addresses_careers/get",
      add: "addresses/addresses_careers/add",
      edit: "addresses/addresses_careers/edit",
      delete: "addresses/addresses_careers/delete",
    },
    addresses_emails: {
      get: "addresses/addresses_emails/get",
      add: "addresses/addresses_emails/add",
      edit: "addresses/addresses_emails/edit",
      delete: "addresses/addresses_emails/delete",
    },
    addresses_workinghours: {
      get: "addresses/addresses_workinghours/get",
      add: "addresses/addresses_workinghours/add",
      edit: "addresses/addresses_workinghours/edit",
      delete: "addresses/addresses_workinghours/delete",
    },
  },
  faqs: {
    get: "faqs/get",
    add: "faqs/add",
    edit: "faqs/edit",
    delete: "faqs/delete",
  },
  users: {
    get: "users/get",
    add: "users/add",
    edit: "users/edit",
    delete: "users/delete",
    get_countries: "users/get_countries",
  },
  admin_logs: {
    get: "admin_logs/get",
    edit: "admin_logs/edit",
  },
  dashboard: {
    topic: "dashboard/topic",
    cateogry: "dashboard/cateogry",
    activity: "dashboard/activity",
    flash_card_used: "dashboard/flash_card_used",
    flash_card_viewed: "dashboard/flash_card_viewed",
    active_users: "dashboard/active_users",
  },
  notification: {
    sendbroadcastnotifcation: "notification/sendbroadcastnotifcation",
  },
  reOrder: "re-order",
};

export default UrlApi;
